export const apiKey = process.env.API_KEY;
import { Fancybox } from "@fancyapps/ui";
import Faqs from "../../../frontend/blocks/faqs/faqs.js";
import HeaderScroll from "./components/HeaderScroll.js";
import FormPopupMessage from "./components/FormPopupMessage.js";
import Carousel from "./components/Carousel.js";
import MobileMenu from "./components/MobileMenu.js";
import Toggle from "./components/Toggle.js";
import FooterToggle from "./components/FooterToggle.js";
import Tabs from "./components/Tabs.js";
import GformUpload from "./components/GformUpload.js";
import SmoothScroll from "./components/SmoothScroll.js";
import NumberCounter from "./components/NumberCounter.js";
import ImageGalleryVideoSlider from "../../../frontend/blocks/image-gallery-video/image-gallery-video";
import InfographicsSlider from "../../../frontend/blocks/infographics/infographics";
import "../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js";
import MediaTextarea from "../../../frontend/blocks/media-textarea/media-textarea";
import MediaTextareaReadMore from "../../../frontend/blocks/media-textarea/media-textarea-read-more";
import Testimonials from '../../../frontend/blocks/testimonials/testimonials.js';
import FlickityMatchHeight from './components/FlickityMatchHeight.js';
import { FlickityAccessibility } from './components/FlickityAccessibility.js';
import FormBlock from "../../../frontend/blocks/form-block/form-block.js";
import MediaColumnsSlider from '../../../frontend/blocks/media-columns/media-columns.js';
import SingleKeyMessage from "./components/SingleKeyMessage.js";
import SubmenuOverlay from './components/SubmenuOverlay.js';
import Animate from "./components/Animate.js";
import UltimateMember from "./components/UltimateMember.js";
import KeyMessagesArchive from "./components/KeyMessagesArchive.js";
import Map from "./components/ProvidersDirectoryMap.js";
import Slider from "./components/Slider.js";
import KnowledgeQuickLinks from "./components/KnowledgeQuickLinks.js";

import aos from "aos";;

Slider();

{ Map(); }

{ Animate(); }

aos.init({
    // mirror: true, // Elements will animate out (reverse animation) when scrolling past them
  });

{
    const formPopupMessage = document.querySelector(".form-popup__wrap--confirmation");

    if (typeof formPopupMessage != "undefined" && formPopupMessage) {
        FormPopupMessage();
    }
}

{
    // Load the match height fix for Flickiy slides
    FlickityMatchHeight();
}

{
    document.addEventListener('DOMContentLoaded', () => {
        FlickityAccessibility();
    });
}

{
    const knowledgeQuickLinks = document.querySelector(".knowledge-quick-links--sticky");
    if (typeof knowledgeQuickLinks != "undefined" && knowledgeQuickLinks != null) {
        KnowledgeQuickLinks();
    }
}

{
    const numberCounter = document.querySelector(".js-count-up");
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const mediaTextarea = document.querySelector(".media-textarea__slider");

    if (typeof mediaTextarea != "undefined" && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const mediaTextareaReadMore = document.querySelector(".media-textarea--read-more");

    if (typeof mediaTextareaReadMore != "undefined" && mediaTextareaReadMore != null) {
        MediaTextareaReadMore();
    }
}

{
    const slider = document.querySelector(".carousel");

    if (typeof slider != "undefined" && slider) {
        Carousel();
    }
}

{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
        SubmenuOverlay();
    }
}

{
    const faqs = document.querySelector("[data-question]");

    if (typeof faqs != "undefined" && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector(".mobile-menu");

    if (typeof mobile_menu != "undefined" && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector("[data-footer-toggle]");

    if (typeof footer_toggle != "undefined" && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector("[data-tabs]");

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector(
        ".image-gallery-video__images--slider"
    );

    if (
        typeof imageGalleryVideoSlider != "undefined" &&
        imageGalleryVideoSlider != null
    ) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const infographicsSlider = document.querySelector(
        ".infographics__images--slider"
    );

    if (
        typeof infographicsSlider != "undefined" &&
        infographicsSlider != null
    ) {
        InfographicsSlider();
    }
}

{
    const testimonials = document.querySelector('[data-testimonials]');
    if (typeof testimonials != "undefined" && testimonials != null) {
        Testimonials(testimonials);
    }
}

{
    const mediaColumnsSlider = document.querySelector('[data-media-columns]');
    if (typeof mediaColumnsSlider != "undefined" && mediaColumnsSlider != null) {
        MediaColumnsSlider(mediaColumnsSlider);
    }
}

{
    const iconColumnsSlides = document.querySelector('[data-icon-columns]');

    if (typeof iconColumnsSlides != "undefined" && iconColumnsSlides != null) {
        IconColumnsSlider(iconColumnsSlides);
    }
}

{
    const formBlock = document.querySelector(".form-block");

    if (typeof formBlock != "undefined" && formBlock) {
        FormBlock();
    }
}

{
    const singleKeyMessage = document.querySelector('.single-key-message');
    if (typeof singleKeyMessage != "undefined" && singleKeyMessage != null) {
        SingleKeyMessage(singleKeyMessage);
    }
}


{
    const ultimateMember = document.querySelector('.um-login .um-form .um-button');
    if (typeof ultimateMember != "undefined" && ultimateMember != null) {
        UltimateMember(ultimateMember);
    }
}

{
    const keyMessagesArchive = document.querySelector('.page-template-page-key-messages');
    const keyMessagesButton = document.querySelector('.archive-key-messages__button');

    if (typeof keyMessagesArchive != "undefined" && keyMessagesArchive != null && typeof keyMessagesButton != "undefined" && keyMessagesButton != null) {
        KeyMessagesArchive(keyMessagesButton);
    }
}
